import { cn } from '@heidi/utils';
import { forwardRef } from 'react';
import {
  indentRailBaseClasses,
  indentRailCollapsedClasses,
  indentRailExpandedClasses,
  indentRailExpandedSmallSpacing,
  indentRailExpandedSpacing,
} from './indent-rail.styles';
import type { IndentRailProps } from './indent-rail.types';

const IndentRail = forwardRef<HTMLDivElement, IndentRailProps>(
  ({ expanded, spacing = 'md', className, 'data-testid': dataTestId, children }, ref) => {
    const conditionalClasses =
      expanded === undefined
        ? null
        : expanded
          ? cn(
              indentRailExpandedClasses,
              spacing === 'sm'
                ? indentRailExpandedSmallSpacing
                : indentRailExpandedSpacing
            )
          : indentRailCollapsedClasses;

    return (
      <div
        ref={ref}
        className={cn(indentRailBaseClasses, conditionalClasses, className)}
        data-testid={dataTestId}
        data-state={
          expanded === undefined ? undefined : expanded ? 'expanded' : 'collapsed'
        }
      >
        {children}
      </div>
    );
  }
);

IndentRail.displayName = 'IndentRail';

export { IndentRail };
